import { CircularProgress } from '@tajawal/ct-web-design-system';
import Styled from './OverlayLoader.styled';

function OverlayLoader(): JSX.Element {
  return (
    <Styled.Wrapper>
      <CircularProgress />
    </Styled.Wrapper>
  );
}

export default OverlayLoader;
